import { render } from "./SettingsLinks.vue?vue&type=template&id=5b3e8284&scoped=true"
import script from "./SettingsLinks.vue?vue&type=script&lang=js"
export * from "./SettingsLinks.vue?vue&type=script&lang=js"

import "./SettingsLinks.vue?vue&type=style&index=0&id=5b3e8284&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3e8284"]])

export default __exports__